import ElementContentMyReview from '@/components/sections/builder/elements/body/customer/customer_review/content';
import ElementSettingMyReview from '@/components/sections/builder/elements/body/customer/customer_review/setting';
import { MyReviewElementDataType } from '@/components/sections/builder/elements/body/customer/customer_review/type';
import { StarFilledIcon } from '@radix-ui/react-icons';

const defaultData: MyReviewElementDataType = {
  name: 'My Review',
  topPadding: 40,
  bottomPadding: 40,
};

export const ElementPreviewIcon = StarFilledIcon;

const CustomerReview = {
  type: 'customer_review',
  group: 'body_customer_review',
  defaultData,
  Element: ElementContentMyReview,
  Setting: ElementSettingMyReview,
  PreviewIcon: ElementPreviewIcon,
  isImmutable: true,
  maxEntries: 1,
};

export default CustomerReview;
